import { pdkAxios } from '@/lib/pdk-axios';
import type { PrimaryCustomer } from '@/models/registry';
import { customerAddressStore } from '@/models/stores';
import type { Address, Deal } from '@/models/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PlusIcon } from 'lucide-react';
import { v4 as uuidv4 } from 'uuid';
import { Button } from '../../ui/button';

const CreateDeliveryAddressButton = ({
  dealId,
  customerId,
}: {
  dealId: Deal['id'];
  customerId: PrimaryCustomer['id'];
}) => {
  const queryClient = useQueryClient();
  const createDeliveryAddressMutation = useMutation({
    onMutate: async ({
      primaryCustomerDeliveryAddress,
    }: {
      primaryCustomerDeliveryAddress: Address;
    }) => {
      customerAddressStore.upsert(primaryCustomerDeliveryAddress);
      // dealStore.updatePrimaryCustomerDeliveryAddress({
      //   id: dealId,
      //   deliveryAddress: primaryCustomerDeliveryAddress,
      // });
    },
    mutationFn: async ({
      primaryCustomerDeliveryAddress,
    }: {
      primaryCustomerDeliveryAddress: Address;
    }): Promise<Address> => {
      //  /deals/:id/primary-customer/:customer_id/delivery-address/create

      const response = await pdkAxios
        .post(
          `/deals/${dealId}/primary-customer/${customerId}/delivery-address/create`,
          {
            id: primaryCustomerDeliveryAddress.id,
          },
        )
        .catch((e) => {
          console.error('Error creating delivery address', e);
          throw e;
        });

      return response.data;
    },
    // onSuccess: (primaryCustomerDeliveryAddress) => {
    //   dealStore.updatePrimaryCustomerDeliveryAddress({
    //     id: dealId,
    //     deliveryAddress: primaryCustomerDeliveryAddress,
    //   });
    // },
    onError: (error) => {
      console.error('Error creating delivery address', error);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['deal', dealId] });
    },
  });

  return (
    <Button
      variant="ghost"
      className="p-0 h-fit w-fit text-gray-500"
      onClick={() =>
        createDeliveryAddressMutation.mutate({
          primaryCustomerDeliveryAddress: {
            id: uuidv4(),
            customer_id: customerId,
            address_type: 'delivery',
            address_line_1: '',
            address_line_2: '',
            city: '',
            state: '',
            postal_code: '',
          },
        })
      }
    >
      <PlusIcon className="w-2 h-2 dark:text-white" />
    </Button>
  );
};

export default CreateDeliveryAddressButton;
